var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.893C4.477 20.893 0 16.416 0 10.893C0 5.37101 4.477 0.893005 10 0.893005C15.523 0.893005 20 5.37101 20 10.893C20 16.416 15.523 20.893 10 20.893ZM10 5.89301C9.73478 5.89301 9.48043 5.99836 9.29289 6.1859C9.10536 6.37343 9 6.62779 9 6.89301V11.893C9 12.1582 9.10536 12.4126 9.29289 12.6001C9.48043 12.7876 9.73478 12.893 10 12.893C10.2652 12.893 10.5196 12.7876 10.7071 12.6001C10.8946 12.4126 11 12.1582 11 11.893V6.89301C11 6.62779 10.8946 6.37343 10.7071 6.1859C10.5196 5.99836 10.2652 5.89301 10 5.89301ZM10 15.893C10.2652 15.893 10.5196 15.7876 10.7071 15.6001C10.8946 15.4126 11 15.1582 11 14.893C11 14.6278 10.8946 14.3734 10.7071 14.1859C10.5196 13.9984 10.2652 13.893 10 13.893C9.73478 13.893 9.48043 13.9984 9.29289 14.1859C9.10536 14.3734 9 14.6278 9 14.893C9 15.1582 9.10536 15.4126 9.29289 15.6001C9.48043 15.7876 9.73478 15.893 10 15.893Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableInfo);
export default __webpack_public_path__ + "static/media/Disable-info.cf28e79348872bf63a7b50822f646b0e.svg";
export { ForwardRef as ReactComponent };